let audioCtx: AudioContext | null = null;

function getAudioContext(): AudioContext {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
  }
  return audioCtx;
}

function playTone(
  ctx: AudioContext,
  frequency: number,
  duration: number,
  startTime: number,
  oscType: OscillatorType = "sine"
) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  osc.type = oscType;
  osc.frequency.value = frequency;

  gain.gain.setValueAtTime(0, startTime);
  gain.gain.linearRampToValueAtTime(0.08, startTime + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);

  osc.connect(gain);
  gain.connect(ctx.destination);

  osc.start(startTime);
  osc.stop(startTime + duration);
}

/**
 * Plays a pleasant, dynamically synthesized chime for task alerts.
 * Respects the user's audio-muted preference stored in LocalStorage.
 * Returns a Promise so callers can await completion of the resume step.
 */
export async function playAlertSound(type: "task" | "notification" | "reminder"): Promise<void> {
  if (localStorage.getItem("task-audio-enabled") === "false") return;

  try {
    const ctx = getAudioContext();

    // Must await resume before scheduling tones — browsers suspend AudioContext
    // until a user gesture has occurred, and .resume() is async.
    if (ctx.state === "suspended") {
      await ctx.resume();
    }

    const now = ctx.currentTime;

    if (type === "task") {
      playTone(ctx, 587.33, 0.15, now);
      playTone(ctx, 880.00, 0.25, now + 0.08);
    } else if (type === "notification") {
      playTone(ctx, 523.25, 0.3, now);
    } else if (type === "reminder") {
      playTone(ctx, 440.00, 0.12, now);
      playTone(ctx, 554.37, 0.12, now + 0.08);
      playTone(ctx, 659.25, 0.25, now + 0.16);
    }
  } catch (e) {
    console.warn("Failed to play synthesized alert sound:", e);
  }
}
